<template>
  <div class="h-100-perc" style="z-index: 0">
    <p id="titulo" class="font-18 ml-5 pt-1 mb-0">Detalhes do departamento</p>

    <div class="charts px-2">
      <MovimentacaoEstoqueDepartamento class="w-50-perc" />
      <RupturasDepartamento class="w-50-perc" />
    </div>
  </div>
</template>

<script>
import MovimentacaoEstoqueDepartamento from "./MovimentacaoEstoqueDepartamento";
import RupturasDepartamento from "./RupturasDepartamento";

export default {
  name: "Index",
  components: {
    MovimentacaoEstoqueDepartamento,
    RupturasDepartamento
  }
}
</script>

<style scoped>
.h-100-perc {
  height: 100%;
}
.w-50-perc {
  width: 50%;
}
#titulo {
  color: rgba(34, 34, 34, 0.82);
  height: 10%;
  font-weight: 600;
  line-height: 21px;
}
.charts {
  display: flex;
  height: 90%;
}
</style>
